import { useQueries } from '@tanstack/react-query';
import { FF_ENABLED_LOCALES } from 'constants/features';
import { featureFlags } from 'services/featureFlags/featureFlags';
import type { SupportedLocalesKeys } from 'utils/translations/translations';
import { GATED_LOCALES, localeCodes } from 'utils/translations/translations';

export function useLocales(): SupportedLocalesKeys[] {
  const flagResults = useQueries({
    queries: GATED_LOCALES.map(locale => ({
      queryKey: ['flags', FF_ENABLED_LOCALES, { locale }],
      queryFn: () => featureFlags.fetch([FF_ENABLED_LOCALES], { locale }),
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    })),
  });

  const enabledGatedLocales = GATED_LOCALES.filter(
    (_, index) => flagResults[index].data?.[FF_ENABLED_LOCALES] === true,
  );

  return localeCodes.filter(
    locale =>
      !GATED_LOCALES.includes(locale) || enabledGatedLocales.includes(locale),
  ) as SupportedLocalesKeys[];
}
